/* eslint-disable no-restricted-globals */
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from "@mui/material";

import { TBudgetProfile } from "../../../../../../../../services/budget/read-budgets";
import { TBudgetProfileLevelDedicatedHours } from "../../../../../../../../services/budget/read-budgets-levels-detailed-by-id";
import {
    defaultCostToFormattedCurrency,
    formatCurrency,
} from "../../../../../../../organization/project/tab-costs/utils";

interface IActivityProfileTableProps {
    items: TBudgetProfile[];
}

export const handleGetAvarageEstimatedHours = (
    data: TBudgetProfileLevelDedicatedHours
) => {
    let result = 0;
    // eslint-disable-next-line no-plusplus
    for (let i = 0; data.length - 1 === i; i++) {
        const profileData = data[i];
        const avarage =
            (profileData.worstPrediction +
                profileData.realPrediction +
                profileData.bestPrediction) /
            2;
        result += avarage;
    }
    return `${result}`;
};

export default function ActivityProfileTable({
    items,
}: IActivityProfileTableProps) {
    // Calcular totais
    const totalEstimatedHours = items.reduce((acc, item) => {
        const hours = parseInt(
            handleGetAvarageEstimatedHours(
                item.BudgetProfileLevelDedicatedHours
            ) || "0",
            10
        );

        return isNaN(hours) ? acc : acc + hours;
    }, 0);

    const totalValue = items.reduce((acc, item) => {
        const totalValue = String(
            Number(item.costPerHour) *
                Number(
                    handleGetAvarageEstimatedHours(
                        item.BudgetProfileLevelDedicatedHours
                    )
                )
        );
        const value = parseFloat(totalValue.replace(/[^\d.-]/g, "") || "0");
        return isNaN(value) ? acc : acc + value;
    }, 0);

    return (
        <TableContainer component={Paper} variant="outlined">
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Função</TableCell>
                        <TableCell>% Cálculo</TableCell>
                        <TableCell>Cálculo de Perfis</TableCell>
                        <TableCell>Custo Hora</TableCell>
                        <TableCell>Horas Estimadas</TableCell>
                        <TableCell>Valor Total</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map((item) => {
                        const totalValue = String(
                            Number(item.costPerHour) *
                                Number(
                                    handleGetAvarageEstimatedHours(
                                        item.BudgetProfileLevelDedicatedHours
                                    )
                                )
                        );
                        return (
                            <TableRow key={item.id_e}>
                                <TableCell sx={{ fontWeight: "medium" }}>
                                    {item.Profile.name}
                                </TableCell>
                                <TableCell>
                                    {item.dependencyPercentage || "0,00%"}
                                </TableCell>
                                <TableCell>
                                    {item.BudgetProfileTimeDependancy.map(
                                        (profileDependecy, index) =>
                                            index ===
                                            item.BudgetProfileTimeDependancy
                                                .length -
                                                1
                                                ? `${profileDependecy.DependsOn.Profile.name}`
                                                : `${profileDependecy.DependsOn.Profile.name}, `
                                    ) || ""}
                                </TableCell>
                                <TableCell>
                                    {item?.costPerHour
                                        ? defaultCostToFormattedCurrency(
                                              item?.costPerHour
                                          )
                                        : "R$ 0,00"}
                                </TableCell>
                                <TableCell>
                                    {handleGetAvarageEstimatedHours(
                                        item.BudgetProfileLevelDedicatedHours
                                    ) || "0"}
                                </TableCell>
                                <TableCell>
                                    {defaultCostToFormattedCurrency(
                                        totalValue
                                    ) || "$ 0,00"}
                                </TableCell>
                            </TableRow>
                        );
                    })}
                    <TableRow>
                        <TableCell
                            colSpan={4}
                            sx={{ textAlign: "left", fontWeight: "bold" }}
                        >
                            Total:
                        </TableCell>

                        <TableCell sx={{ fontWeight: "bold" }}>
                            {totalEstimatedHours}
                        </TableCell>
                        <TableCell sx={{ fontWeight: "bold" }}>
                            {formatCurrency(String(totalValue))}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}
